
export default {
  props: {
    store: {type: Object, required: true}
  },
  emits: ['update'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    my_store() {
      return this.store
    },
    topics: {
      get() {
        return this.my_store.af_topics || []
      },
      set(ids) {
        this.my_store.af_topics = ids
        this.$emit('update')
      }
    },
    companies: {
      get() {
        return this.my_store.af_companies || []
      },
      set(ids) {
        this.my_store.af_companies = ids
        this.$emit('update')
      }
    }
  }
}
